import { render, staticRenderFns } from "./ErpApplicationList.vue?vue&type=template&id=04401d88"
import script from "./ErpApplicationList.vue?vue&type=script&lang=js"
export * from "./ErpApplicationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports